module.exports = __webpack_public_path__ + "img/sao-tome-and-principe.c3055812.svg";